import React from "react";
import "../css/SinceStamp.css";

export default function SinceStamp() {
  return (
    <div className="since-stamp" aria-label="Since 1990">
      <svg viewBox="0 0 120 120" className="since-stamp__svg">
        {/* Outer circle */}
        <circle
          cx="60"
          cy="60"
          r="56"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        {/* Inner circle */}
        <circle
          cx="60"
          cy="60"
          r="44"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
          strokeDasharray="3 3"
        />
        {/* Curved text path */}
        <defs>
          <path id="topArc" d="M 18,60 A 42,42 0 0 1 102,60" fill="none" />
          <path id="bottomArc" d="M 102,60 A 42,42 0 0 1 18,60" fill="none" />
        </defs>
        <text className="since-stamp__text">
          <textPath href="#topArc" startOffset="50%" textAnchor="middle">
            ★ ESTABLISHED ★
          </textPath>
        </text>
        <text className="since-stamp__text">
          <textPath href="#bottomArc" startOffset="50%" textAnchor="middle">
            QUALITY • TRUST
          </textPath>
        </text>
      </svg>
      <div className="since-stamp__center">
        <span className="since-stamp__since">SINCE</span>
        <span className="since-stamp__year">1990</span>
      </div>
    </div>
  );
}
